import React from "react";
import {withTranslation} from "react-i18next";

class PasaporteDisabled extends React.Component {
    render() {
        return (
            <div className="col-xl-6">
                <div className="card">
                    <div className="card-body p-4">
                        <div className="p-2">
                            <h5 className="mb-5 text-center">Consulta Pasaporte.</h5>
                            <p>La consulta de pasaporte está deshabilitada temporalmente. Puede recoger su documento en un plazo de 20 días desde la fecha de tramitación.</p>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default withTranslation()(PasaporteDisabled);